export const LANGUAGES = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

export const AI_LANG_NAME = {
  it: "italiano", en: "English", es: "español", fr: "français", de: "Deutsch",
};

// Muscle names per language (keys match backend primary_muscle IT values)
export const MUSCLE_NAMES = {
  Petto: { it: "Petto", en: "Chest", es: "Pecho", fr: "Pectoraux", de: "Brust" },
  Dorso: { it: "Dorso", en: "Back", es: "Espalda", fr: "Dos", de: "Rücken" },
  Gambe: { it: "Gambe", en: "Legs", es: "Piernas", fr: "Jambes", de: "Beine" },
  Spalle: { it: "Spalle", en: "Shoulders", es: "Hombros", fr: "Épaules", de: "Schultern" },
  Braccia: { it: "Braccia", en: "Arms", es: "Brazos", fr: "Bras", de: "Arme" },
  Addome: { it: "Addome", en: "Core", es: "Abdomen", fr: "Abdos", de: "Bauch" },
};

const T = {
  it: {
    brand_tag: "SCHEDE PALESTRA & FORZA",
    nav_dashboard: "Home", nav_saved: "I miei allenamenti", nav_pricing: "Abbonamento",
    login: "Accedi con Google", logout: "Esci",
    hero_title: "Costruisci la tua Forza",
    hero_sub: "Crea, genera con l'AI o scegli schede pronte. Con spiegazioni, illustrazioni e video per ogni esercizio.",
    hero_cta: "Inizia gratis — 14 giorni",
    trial_free: "Prova gratuita 14 giorni",
    choose_mode: "Scegli come creare la tua scheda",
    mode_manual_title: "Crea la tua Scheda", mode_manual_sub: "Personalizzazione totale",
    mode_manual_desc: "Componi la scheda esercizio per esercizio. Serie, ripetizioni, recupero e carichi.",
    mode_ai_title: "Scheda Personalizzata", mode_ai_sub: "Su misura per te",
    mode_ai_desc: "Rispondi a poche domande e ricevi una scheda su misura per obiettivo, livello e attrezzatura.",
    mode_std_title: "Schede Pronte", mode_std_sub: "Template certificati",
    mode_std_desc: "Programmi pronti e testati: Total Body, Forza, Calisthenics o Macchinari.",
    beginner_mode: "Modalità Principiante", beginner_hint: "Mostra spiegazioni, illustrazioni e video",
    start: "Inizia", goal: "Obiettivo", split: "Tipo di scheda", equipment: "Attrezzatura",
    level: "Livello", days: "Giorni a settimana", muscles: "Gruppi muscolari", notes: "Note (opzionale)",
    generate: "Crea la mia Scheda", generating: "Creazione in corso...",
    add_exercise: "Aggiungi esercizio", title_ph: "Titolo scheda",
    sets: "Serie", reps: "Ripetizioni", rest: "Recupero", load: "Carico",
    execution: "Come si esegue", tip: "Consiglio per principianti", mistakes: "Errore da evitare",
    video: "Video dimostrativo", muscle_worked: "Muscolo allenato",
    export_print: "Stampa / PDF", export_png: "Salva PNG", export_share: "Condividi", save_plan: "Salva",
    evolve: "Evolvi in scheda successiva", evolving: "Evoluzione...", generation: "Generazione",
    saved_title: "I miei allenamenti", no_saved: "Nessuna scheda salvata ancora.",
    view: "Apri", delete: "Elimina", back: "Indietro",
    pricing_title: "Abbonamento", pricing_sub: "Prime 2 settimane gratis. Poi un prezzo accessibile a tutti.",
    monthly: "Mensile", yearly: "Annuale", per_month: "/mese", per_year: "/anno",
    subscribe: "Abbonati", best_value: "Più conveniente", current: "Attivo",
    trial_days_left: "giorni di prova rimasti", trial_ended: "Prova terminata — abbonati per continuare",
    login_required: "Accedi per salvare e generare schede", link_copied: "Link copiato negli appunti!",
    plan_saved: "Scheda salvata!", need_sub: "Prova terminata. Abbonati per continuare a creare schede.",
    day: "Giorno", overview: "Panoramica",
    nav_diary: "Diario", nav_calendar: "Calendario",
    diary_title: "Diario Allenamenti", diary_sub: "Segna gli allenamenti fatti e monitora i progressi",
    mark_done: "Segna come completato", log_saved: "Allenamento registrato!", log_note_ph: "Come è andata? (opzionale)",
    sessions_total: "Allenamenti totali", this_week: "Questa settimana", streak: "Giorni di fila",
    no_logs: "Nessun allenamento registrato ancora.", last7: "Ultimi 7 giorni",
    calendar_title: "Calendario Settimanale", calendar_sub: "Assegna i giorni della scheda ai giorni della settimana",
    rest_day: "Riposo", today_workout: "Oggi tocca", no_today: "Oggi è giorno di riposo",
    select_plan: "Scegli scheda", select_day: "Scegli giorno", schedule_saved: "Calendario salvato!",
    date_lbl: "Data", note_lbl: "Nota",
    weight_lbl: "Peso (kg)", reps_lbl: "Rip.",
    unlock_title: "Sblocca tutti i giorni", unlock_sub: "Abbonati per vedere l'intera scheda, generare schede su misura e molto altro.", unlock_cta: "Sblocca con Pulsar Pro",
    referral_title: "Invita un amico", referral_sub: "Tu e il tuo amico ricevete giorni di prova extra gratis.", invite_count: "Amici invitati", copy_link: "Copia link invito", referral_reward: "+14 giorni per te, +7 per loro",
    exercise_progress: "Progressi esercizio", select_exercise: "Scegli esercizio", no_progress: "Registra i carichi per vedere i progressi.", made_with: "Creato con VOLT",
    progression_lbl: "Progressione carichi / Note", progression_ph: "Es. Sett.1: 40kg · Sett.2: 45kg · Sett.3: 50kg...",
    add_from_library: "Dalla libreria", write_freely: "Scrivi il tuo esercizio",
  },
  en: {
    brand_tag: "GYM & STRENGTH PLANS",
    nav_dashboard: "Home", nav_saved: "My workouts", nav_pricing: "Subscription",
    login: "Sign in with Google", logout: "Log out",
    hero_title: "Build Your Strength",
    hero_sub: "Create, generate with AI or pick ready-made plans. With explanations, illustrations and videos for every exercise.",
    hero_cta: "Start free — 14 days",
    trial_free: "14-day free trial",
    choose_mode: "Choose how to create your plan",
    mode_manual_title: "Create Your Plan", mode_manual_sub: "Full customization",
    mode_manual_desc: "Build your plan exercise by exercise. Sets, reps, rest and loads.",
    mode_ai_title: "Personalized Plan", mode_ai_sub: "Tailored for you",
    mode_ai_desc: "Answer a few questions and get a plan tailored to your goal, level and equipment.",
    mode_std_title: "Ready Plans", mode_std_sub: "Certified templates",
    mode_std_desc: "Ready, tested programs: Full Body, Strength, Calisthenics or Machines.",
    beginner_mode: "Beginner Mode", beginner_hint: "Show explanations, illustrations and videos",
    start: "Start", goal: "Goal", split: "Plan type", equipment: "Equipment",
    level: "Level", days: "Days per week", muscles: "Muscle groups", notes: "Notes (optional)",
    generate: "Create my Plan", generating: "Creating...",
    add_exercise: "Add exercise", title_ph: "Plan title",
    sets: "Sets", reps: "Reps", rest: "Rest", load: "Load",
    execution: "How to do it", tip: "Beginner tip", mistakes: "Mistake to avoid",
    video: "Demo video", muscle_worked: "Muscle worked",
    export_print: "Print / PDF", export_png: "Save PNG", export_share: "Share", save_plan: "Save",
    evolve: "Evolve to next plan", evolving: "Evolving...", generation: "Generation",
    saved_title: "My workouts", no_saved: "No saved plans yet.",
    view: "Open", delete: "Delete", back: "Back",
    pricing_title: "Subscription", pricing_sub: "First 2 weeks free. Then a price everyone can afford.",
    monthly: "Monthly", yearly: "Yearly", per_month: "/mo", per_year: "/yr",
    subscribe: "Subscribe", best_value: "Best value", current: "Active",
    trial_days_left: "trial days left", trial_ended: "Trial ended — subscribe to continue",
    login_required: "Sign in to save and generate plans", link_copied: "Link copied to clipboard!",
    plan_saved: "Plan saved!", need_sub: "Trial ended. Subscribe to keep creating plans.",
    day: "Day", overview: "Overview",
    nav_diary: "Diary", nav_calendar: "Calendar",
    diary_title: "Workout Diary", diary_sub: "Log your completed workouts and track progress",
    mark_done: "Mark as done", log_saved: "Workout logged!", log_note_ph: "How did it go? (optional)",
    sessions_total: "Total workouts", this_week: "This week", streak: "Day streak",
    no_logs: "No workouts logged yet.", last7: "Last 7 days",
    calendar_title: "Weekly Calendar", calendar_sub: "Assign plan days to weekdays",
    rest_day: "Rest", today_workout: "Today's workout", no_today: "Today is a rest day",
    select_plan: "Choose plan", select_day: "Choose day", schedule_saved: "Calendar saved!",
    date_lbl: "Date", note_lbl: "Note",
    weight_lbl: "Weight (kg)", reps_lbl: "Reps",
    unlock_title: "Unlock all days", unlock_sub: "Subscribe to see the full plan, generate tailored plans and more.", unlock_cta: "Unlock with Pulsar Pro",
    referral_title: "Invite a friend", referral_sub: "You and your friend both get extra free trial days.", invite_count: "Friends invited", copy_link: "Copy invite link", referral_reward: "+14 days for you, +7 for them",
    exercise_progress: "Exercise progress", select_exercise: "Choose exercise", no_progress: "Log your loads to see progress.", made_with: "Made with VOLT",
    progression_lbl: "Load progression / Notes", progression_ph: "E.g. Wk1: 40kg · Wk2: 45kg · Wk3: 50kg...",
    add_from_library: "From library", write_freely: "Write your own exercise",
  },
  es: {
    brand_tag: "PLANES DE GIMNASIO Y FUERZA",
    nav_dashboard: "Inicio", nav_saved: "Mis entrenamientos", nav_pricing: "Suscripción",
    login: "Entrar con Google", logout: "Salir",
    hero_title: "Construye tu Fuerza",
    hero_sub: "Crea, genera con IA o elige planes listos. Con explicaciones, ilustraciones y vídeos para cada ejercicio.",
    hero_cta: "Empieza gratis — 14 días", trial_free: "Prueba gratis 14 días",
    choose_mode: "Elige cómo crear tu plan",
    mode_manual_title: "Crea tu Plan", mode_manual_sub: "Personalización total",
    mode_manual_desc: "Crea tu plan ejercicio por ejercicio. Series, repeticiones, descanso y cargas.",
    mode_ai_title: "Plan Personalizado", mode_ai_sub: "A tu medida",
    mode_ai_desc: "Responde unas preguntas y recibe un plan a tu medida según objetivo, nivel y equipo.",
    mode_std_title: "Planes Listos", mode_std_sub: "Plantillas certificadas",
    mode_std_desc: "Programas listos y probados: Full Body, Fuerza, Calistenia o Máquinas.",
    beginner_mode: "Modo Principiante", beginner_hint: "Muestra explicaciones, ilustraciones y vídeos",
    start: "Empezar", goal: "Objetivo", split: "Tipo de plan", equipment: "Equipo",
    level: "Nivel", days: "Días por semana", muscles: "Grupos musculares", notes: "Notas (opcional)",
    generate: "Crear mi Plan", generating: "Creando...",
    add_exercise: "Añadir ejercicio", title_ph: "Título del plan",
    sets: "Series", reps: "Reps", rest: "Descanso", load: "Carga",
    execution: "Cómo hacerlo", tip: "Consejo principiante", mistakes: "Error a evitar",
    video: "Vídeo demostrativo", muscle_worked: "Músculo trabajado",
    export_print: "Imprimir / PDF", export_png: "Guardar PNG", export_share: "Compartir", save_plan: "Guardar",
    evolve: "Evolucionar al siguiente", evolving: "Evolucionando...", generation: "Generación",
    saved_title: "Mis entrenamientos", no_saved: "Aún no hay planes guardados.",
    view: "Abrir", delete: "Eliminar", back: "Atrás",
    pricing_title: "Suscripción", pricing_sub: "Primeras 2 semanas gratis. Luego un precio accesible para todos.",
    monthly: "Mensual", yearly: "Anual", per_month: "/mes", per_year: "/año",
    subscribe: "Suscribirse", best_value: "Mejor valor", current: "Activo",
    trial_days_left: "días de prueba restantes", trial_ended: "Prueba terminada — suscríbete para continuar",
    login_required: "Entra para guardar y generar planes", link_copied: "¡Enlace copiado!",
    plan_saved: "¡Plan guardado!", need_sub: "Prueba terminada. Suscríbete para seguir creando planes.",
    day: "Día", overview: "Resumen",
    nav_diary: "Diario", nav_calendar: "Calendario",
    diary_title: "Diario de Entrenamientos", diary_sub: "Registra tus entrenamientos y controla el progreso",
    mark_done: "Marcar como hecho", log_saved: "¡Entrenamiento registrado!", log_note_ph: "¿Cómo fue? (opcional)",
    sessions_total: "Entrenamientos totales", this_week: "Esta semana", streak: "Días seguidos",
    no_logs: "Aún no hay entrenamientos registrados.", last7: "Últimos 7 días",
    calendar_title: "Calendario Semanal", calendar_sub: "Asigna los días del plan a los días de la semana",
    rest_day: "Descanso", today_workout: "Hoy toca", no_today: "Hoy es día de descanso",
    select_plan: "Elige plan", select_day: "Elige día", schedule_saved: "¡Calendario guardado!",
    date_lbl: "Fecha", note_lbl: "Nota",
    weight_lbl: "Peso (kg)", reps_lbl: "Reps",
    unlock_title: "Desbloquea todos los días", unlock_sub: "Suscríbete para ver el plan completo, generar planes a medida y más.", unlock_cta: "Desbloquear con Pulsar Pro",
    referral_title: "Invita a un amigo", referral_sub: "Tú y tu amigo recibís días de prueba extra gratis.", invite_count: "Amigos invitados", copy_link: "Copiar enlace", referral_reward: "+14 días para ti, +7 para él",
    exercise_progress: "Progreso del ejercicio", select_exercise: "Elige ejercicio", no_progress: "Registra tus cargas para ver el progreso.", made_with: "Hecho con VOLT",
    progression_lbl: "Progresión de cargas / Notas", progression_ph: "Ej. Sem.1: 40kg · Sem.2: 45kg · Sem.3: 50kg...",
    add_from_library: "De la biblioteca", write_freely: "Escribe tu ejercicio",
  },
  fr: {
    brand_tag: "PROGRAMMES MUSCU & FORCE",
    nav_dashboard: "Accueil", nav_saved: "Mes séances", nav_pricing: "Abonnement",
    login: "Se connecter avec Google", logout: "Déconnexion",
    hero_title: "Construis ta Force",
    hero_sub: "Crée, génère avec l'IA ou choisis des programmes prêts. Avec explications, illustrations et vidéos.",
    hero_cta: "Commence gratuit — 14 jours", trial_free: "Essai gratuit 14 jours",
    choose_mode: "Choisis comment créer ton programme",
    mode_manual_title: "Crée ton Programme", mode_manual_sub: "Personnalisation totale",
    mode_manual_desc: "Compose ton programme exercice par exercice. Séries, répétitions, repos et charges.",
    mode_ai_title: "Programme Personnalisé", mode_ai_sub: "Sur mesure",
    mode_ai_desc: "Réponds à quelques questions et reçois un programme sur mesure selon objectif, niveau et équipement.",
    mode_std_title: "Programmes Prêts", mode_std_sub: "Modèles certifiés",
    mode_std_desc: "Programmes prêts et testés : Full Body, Force, Callisthénie ou Machines.",
    beginner_mode: "Mode Débutant", beginner_hint: "Affiche explications, illustrations et vidéos",
    start: "Commencer", goal: "Objectif", split: "Type de programme", equipment: "Équipement",
    level: "Niveau", days: "Jours par semaine", muscles: "Groupes musculaires", notes: "Notes (facultatif)",
    generate: "Créer mon Programme", generating: "Création...",
    add_exercise: "Ajouter un exercice", title_ph: "Titre du programme",
    sets: "Séries", reps: "Reps", rest: "Repos", load: "Charge",
    execution: "Comment faire", tip: "Conseil débutant", mistakes: "Erreur à éviter",
    video: "Vidéo démo", muscle_worked: "Muscle travaillé",
    export_print: "Imprimer / PDF", export_png: "Enregistrer PNG", export_share: "Partager", save_plan: "Enregistrer",
    evolve: "Faire évoluer", evolving: "Évolution...", generation: "Génération",
    saved_title: "Mes séances", no_saved: "Aucun programme enregistré.",
    view: "Ouvrir", delete: "Supprimer", back: "Retour",
    pricing_title: "Abonnement", pricing_sub: "2 premières semaines gratuites. Puis un prix accessible à tous.",
    monthly: "Mensuel", yearly: "Annuel", per_month: "/mois", per_year: "/an",
    subscribe: "S'abonner", best_value: "Meilleur prix", current: "Actif",
    trial_days_left: "jours d'essai restants", trial_ended: "Essai terminé — abonne-toi pour continuer",
    login_required: "Connecte-toi pour enregistrer et générer", link_copied: "Lien copié !",
    plan_saved: "Programme enregistré !", need_sub: "Essai terminé. Abonne-toi pour continuer à créer.",
    day: "Jour", overview: "Aperçu",
    nav_diary: "Journal", nav_calendar: "Calendrier",
    diary_title: "Journal d'Entraînement", diary_sub: "Enregistre tes séances et suis tes progrès",
    mark_done: "Marquer comme fait", log_saved: "Séance enregistrée !", log_note_ph: "Comment ça s'est passé ? (facultatif)",
    sessions_total: "Séances totales", this_week: "Cette semaine", streak: "Jours d'affilée",
    no_logs: "Aucune séance enregistrée.", last7: "7 derniers jours",
    calendar_title: "Calendrier Hebdomadaire", calendar_sub: "Assigne les jours du programme aux jours de la semaine",
    rest_day: "Repos", today_workout: "Au programme aujourd'hui", no_today: "Aujourd'hui c'est repos",
    select_plan: "Choisir un programme", select_day: "Choisir un jour", schedule_saved: "Calendrier enregistré !",
    date_lbl: "Date", note_lbl: "Note",
    weight_lbl: "Poids (kg)", reps_lbl: "Reps",
    unlock_title: "Débloque tous les jours", unlock_sub: "Abonne-toi pour voir le programme complet, générer des programmes sur mesure et plus.", unlock_cta: "Débloquer avec Pulsar Pro",
    referral_title: "Invite un ami", referral_sub: "Toi et ton ami recevez des jours d'essai gratuits en plus.", invite_count: "Amis invités", copy_link: "Copier le lien", referral_reward: "+14 jours pour toi, +7 pour lui",
    exercise_progress: "Progression de l'exercice", select_exercise: "Choisir un exercice", no_progress: "Enregistre tes charges pour voir la progression.", made_with: "Créé avec VOLT",
    progression_lbl: "Progression des charges / Notes", progression_ph: "Ex. Sem.1: 40kg · Sem.2: 45kg · Sem.3: 50kg...",
    add_from_library: "Depuis la bibliothèque", write_freely: "Écris ton exercice",
  },
  de: {
    brand_tag: "GYM- & KRAFTPLÄNE",
    nav_dashboard: "Start", nav_saved: "Meine Workouts", nav_pricing: "Abo",
    login: "Mit Google anmelden", logout: "Abmelden",
    hero_title: "Baue deine Kraft auf",
    hero_sub: "Erstelle, generiere mit KI oder wähle fertige Pläne. Mit Erklärungen, Illustrationen und Videos.",
    hero_cta: "Kostenlos starten — 14 Tage", trial_free: "14 Tage kostenlos",
    choose_mode: "Wähle, wie du deinen Plan erstellst",
    mode_manual_title: "Eigenen Plan erstellen", mode_manual_sub: "Volle Anpassung",
    mode_manual_desc: "Baue deinen Plan Übung für Übung. Sätze, Wiederholungen, Pause und Lasten.",
    mode_ai_title: "Personalisierter Plan", mode_ai_sub: "Für dich zugeschnitten",
    mode_ai_desc: "Beantworte ein paar Fragen und erhalte einen Plan nach Ziel, Level und Ausrüstung.",
    mode_std_title: "Fertige Pläne", mode_std_sub: "Zertifizierte Vorlagen",
    mode_std_desc: "Fertige, getestete Programme: Ganzkörper, Kraft, Calisthenics oder Maschinen.",
    beginner_mode: "Anfänger-Modus", beginner_hint: "Zeigt Erklärungen, Illustrationen und Videos",
    start: "Start", goal: "Ziel", split: "Plantyp", equipment: "Ausrüstung",
    level: "Level", days: "Tage pro Woche", muscles: "Muskelgruppen", notes: "Notizen (optional)",
    generate: "Meinen Plan erstellen", generating: "Erstelle...",
    add_exercise: "Übung hinzufügen", title_ph: "Plantitel",
    sets: "Sätze", reps: "Wdh.", rest: "Pause", load: "Last",
    execution: "So geht's", tip: "Anfänger-Tipp", mistakes: "Fehler vermeiden",
    video: "Demo-Video", muscle_worked: "Trainierter Muskel",
    export_print: "Drucken / PDF", export_png: "PNG speichern", export_share: "Teilen", save_plan: "Speichern",
    evolve: "Zum nächsten Plan", evolving: "Entwickle...", generation: "Generation",
    saved_title: "Meine Workouts", no_saved: "Noch keine gespeicherten Pläne.",
    view: "Öffnen", delete: "Löschen", back: "Zurück",
    pricing_title: "Abo", pricing_sub: "Erste 2 Wochen gratis. Dann ein Preis für alle erschwinglich.",
    monthly: "Monatlich", yearly: "Jährlich", per_month: "/Mon.", per_year: "/Jahr",
    subscribe: "Abonnieren", best_value: "Bester Preis", current: "Aktiv",
    trial_days_left: "Testtage übrig", trial_ended: "Test beendet — abonniere zum Weitermachen",
    login_required: "Melde dich an, um Pläne zu speichern und zu generieren", link_copied: "Link kopiert!",
    plan_saved: "Plan gespeichert!", need_sub: "Test beendet. Abonniere, um weiter Pläne zu erstellen.",
    day: "Tag", overview: "Überblick",
    nav_diary: "Tagebuch", nav_calendar: "Kalender",
    diary_title: "Trainings-Tagebuch", diary_sub: "Protokolliere Workouts und verfolge Fortschritte",
    mark_done: "Als erledigt markieren", log_saved: "Workout gespeichert!", log_note_ph: "Wie lief es? (optional)",
    sessions_total: "Workouts gesamt", this_week: "Diese Woche", streak: "Tage in Folge",
    no_logs: "Noch keine Workouts protokolliert.", last7: "Letzte 7 Tage",
    calendar_title: "Wochenkalender", calendar_sub: "Weise Plan-Tage den Wochentagen zu",
    rest_day: "Ruhe", today_workout: "Heute dran", no_today: "Heute ist Ruhetag",
    select_plan: "Plan wählen", select_day: "Tag wählen", schedule_saved: "Kalender gespeichert!",
    date_lbl: "Datum", note_lbl: "Notiz",
    weight_lbl: "Gewicht (kg)", reps_lbl: "Wdh.",
    unlock_title: "Alle Tage freischalten", unlock_sub: "Abonniere, um den ganzen Plan zu sehen, maßgeschneiderte Pläne zu erstellen und mehr.", unlock_cta: "Mit Pulsar Pro freischalten",
    referral_title: "Freund einladen", referral_sub: "Du und dein Freund erhaltet extra Gratis-Testtage.", invite_count: "Eingeladene Freunde", copy_link: "Einladungslink kopieren", referral_reward: "+14 Tage für dich, +7 für ihn",
    exercise_progress: "Übungsfortschritt", select_exercise: "Übung wählen", no_progress: "Protokolliere deine Lasten, um Fortschritte zu sehen.", made_with: "Erstellt mit VOLT",
    progression_lbl: "Lastprogression / Notizen", progression_ph: "z.B. Wo.1: 40kg · Wo.2: 45kg · Wo.3: 50kg...",
    add_from_library: "Aus Bibliothek", write_freely: "Eigene Übung schreiben",
  },
};

export function detectLang() {
  const saved = localStorage.getItem("pulsar_lang");
  if (saved) return saved;
  const nav = (navigator.language || "it").slice(0, 2);
  return T[nav] ? nav : "it";
}

export function tr(lang, key) {
  return (T[lang] && T[lang][key]) || T.it[key] || key;
}

export function muscleName(muscle, lang) {
  if (!muscle) return "";
  const key = Object.keys(MUSCLE_NAMES).find((m) => muscle.toLowerCase().includes(m.toLowerCase()));
  return key ? MUSCLE_NAMES[key][lang] || muscle : muscle;
}

export const WEEKDAYS = {
  it: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
  en: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  es: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
  fr: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
  de: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
};

export function weekdays(lang) {
  return WEEKDAYS[lang] || WEEKDAYS.it;
}
